import { render } from "./HeaderFile.component.vue?vue&type=template&id=9efe10c0&ts=true"
import script from "./HeaderFile.component.vue?vue&type=script&lang=ts"
export * from "./HeaderFile.component.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__